export default "__VITE_ASSET__BnrA8hV0__"